import { Badge } from '@change/ds-core-ui/next';

export function PostalCodeValue({ postalCode }: { postalCode: string }): React.JSX.Element {
	return <Badge label={postalCode} size="small" variant="neutral" />;
}
